import React from 'react';

const styles = {
    body: {
        backgroundColor: '#f0fdf4', // Green-50
        fontFamily: '"Inter", sans-serif',
        margin: 0,
        padding: 0,
        width: '100%',
    },
    container: {
        maxWidth: '600px',
        margin: '0 auto',
        backgroundColor: '#ffffff',
        border: '1px solid #dcfce7', // Green-100
        borderRadius: '12px',
        marginTop: '40px',
        overflow: 'hidden',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
    },
    header: {
        backgroundColor: '#ffffff',
        padding: '24px',
        textAlign: 'center' as const,
        borderBottom: '1px solid #f0fdf4',
    },
    logo: {
        color: '#15803d', // Green-700
        fontSize: '22px',
        fontWeight: 800,
        letterSpacing: '-1px',
        textDecoration: 'none',
    },
    content: {
        padding: '40px',
    },
    icon: {
        width: '64px',
        height: '64px',
        backgroundColor: '#dcfce7', // Green-100
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 24px',
        color: '#16a34a', // Green-600
        fontSize: '32px',
    },
    heading: {
        fontSize: '24px',
        lineHeight: '32px',
        color: '#166534', // Green-800
        margin: '0 0 16px',
        fontWeight: 700,
        textAlign: 'center' as const,
    },
    text: {
        fontSize: '16px',
        lineHeight: '26px',
        color: '#374151', // Gray-700
        margin: '0 0 24px',
    },
    safetyTip: {
        backgroundColor: '#ecfdf5', // Emerald-50
        borderLeft: '4px solid #10b981', // Emerald-500
        padding: '20px',
        borderRadius: '4px',
        marginBottom: '24px',
    },
    tipTitle: {
        fontSize: '14px',
        fontWeight: 700,
        color: '#065f46', // Emerald-800
        marginBottom: '8px',
        display: 'block',
        textTransform: 'uppercase' as const,
    },
    button: {
        display: 'block',
        width: '100%',
        backgroundColor: '#16a34a', // Green-600
        color: '#ffffff',
        textDecoration: 'none',
        padding: '16px 0',
        fontSize: '16px',
        fontWeight: 600,
        borderRadius: '8px',
        textAlign: 'center' as const,
    },
    footer: {
        backgroundColor: '#f9fafb',
        padding: '24px',
        textAlign: 'center' as const,
        fontSize: '12px',
        color: '#6b7280',
        borderTop: '1px solid #e5e7eb',
    }
};

export const SafetyAdvisoryEmail = () => {
    return (
        <div style={styles.body as any}>
            <table role="presentation" cellPadding="0" cellSpacing="0" style={{ width: '100%' }}>
                <tr>
                    <td align="center">
                        <div style={styles.container}>
                            {/* Header */}
                            <div style={styles.header}>
                                <span style={styles.logo}>LISTO</span>
                            </div>

                            {/* Content */}
                            <div style={styles.content}>
                                <div style={styles.icon}>🛡️</div>
                                <h1 style={styles.heading}>Safety Advisory: Updated Guidelines</h1>
                                <p style={styles.text}>
                                    At Listo, your safety is our top priority. We've updated our community guidelines
                                    to ensure transparent and respectful interactions for all members.
                                </p>

                                <div style={styles.safetyTip}>
                                    <span style={styles.tipTitle}>Core Principle: Clear Intent</span>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#064e3b' }}>
                                        Always verify the intent of a connection before sharing personal details.
                                        Use our new "Verification Badge" feature to request identity confirmation.
                                    </p>
                                </div>

                                <a href="#" style={styles.button}>Review Safety Guidelines</a>
                            </div>

                            {/* Footer */}
                            <div style={styles.footer}>
                                <p style={{ margin: 0 }}>
                                    Need help? Contact <a href="#" style={{ color: '#16a34a' }}>Trust & Safety</a>.
                                </p>
                                <p style={{ margin: '8px 0 0' }}>
                                    © 2026 Listo Platform.
                                </p>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    );
};
